import React from 'react';
import { AuthGuard } from '@/components/common/AuthGuard';
import { UserRulesManager } from '@/components/dashboard/UserRulesManager';

const ContentFiltering: React.FC = () => {
  return (
    <AuthGuard>
      <div className="container mx-auto py-8 px-4">
        <div className="max-w-6xl mx-auto">
          <UserRulesManager />
        </div>
      </div>
    </AuthGuard>
  );
};

export default ContentFiltering;